module.exports = __webpack_public_path__ + "img/book19.0f722d18.jpg";